import {  useState, useRef } from "react";
import useOnClickOutside from "_hooks/useOnClickOutside";
import { PageLoader } from ".";

const ExportFileButton = (props) => {
  const {getDownload , load, getPdfDownload= () => {}, hasPdf = false  } = props;
  const [btnClick, setBtnClick] = useState(false);
  const btnToogle = () => setBtnClick(!btnClick);
  const exportDropList = useRef(null);
  useOnClickOutside(exportDropList, () => setBtnClick(false));
  return (
    <div
      className={`export-filter relative ${btnClick ? "popup-open" : ""}`}
      ref={exportDropList}
    >
      <button
        type="button"
        className="export-filter-btn relative d-flex align-center justify-center"
        onClick={btnToogle}
      >
        Export File
      </button>
      <div className="export-file-popup d-flex flex-start flex-col">
        {load ? (
          <PageLoader />
        ) : (
          <>
            {hasPdf && <a
              onClick={() => getPdfDownload()}
              className="cursor-pointer d-flex align-center"
            >
              .PDF
            </a>}
            <a
              onClick={() => getDownload("xls")}
              className="cursor-pointer d-flex align-center"
            >
              .XLS
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export { ExportFileButton };
